
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Accessibility, Plus, Minus, Eye, RotateCcw } from "lucide-react";

export function AccessibilityButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [fontSize, setFontSize] = useState(16);
  const [contrast, setContrast] = useState(false);

  const increaseFontSize = () => {
    const newSize = Math.min(fontSize + 2, 24);
    setFontSize(newSize);
    document.documentElement.style.fontSize = `${newSize}px`;
  };

  const decreaseFontSize = () => {
    const newSize = Math.max(fontSize - 2, 12);
    setFontSize(newSize);
    document.documentElement.style.fontSize = `${newSize}px`;
  };

  const toggleContrast = () => {
    setContrast(!contrast);
    if (!contrast) {
      document.documentElement.style.filter = "contrast(150%) brightness(150%)";
    } else {
      document.documentElement.style.filter = "none";
    }
  };

  const resetAccessibility = () => {
    setFontSize(16);
    setContrast(false);
    document.documentElement.style.fontSize = "16px";
    document.documentElement.style.filter = "none";
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {isOpen && (
        <div className="mb-3 w-60 bg-white rounded-2xl shadow-xl border border-gray-100 p-4">
          <h3 className="font-bold font-primary text-sm text-gray-800 mb-3 flex items-center gap-2">
            <Accessibility className="w-4 h-4 text-brand-primary" />
            Acessibilidade
          </h3>
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-primary text-gray-600">Tamanho da fonte</span>
              <div className="flex items-center gap-1">
                <button onClick={decreaseFontSize} className="w-7 h-7 rounded-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-colors">
                  <Minus className="w-3 h-3" />
                </button>
                <span className="text-xs font-bold font-primary w-7 text-center">{fontSize}</span>
                <button onClick={increaseFontSize} className="w-7 h-7 rounded-lg border border-gray-200 flex items-center justify-center hover:bg-gray-50 transition-colors">
                  <Plus className="w-3 h-3" />
                </button>
              </div>
            </div>
            <button onClick={toggleContrast} className="w-full flex items-center gap-2 text-xs font-primary text-gray-600 px-2 py-2 rounded-lg hover:bg-gray-50 transition-colors">
              <Eye className="w-3.5 h-3.5" />
              {contrast ? "Contraste Normal" : "Alto Contraste"}
            </button>
            <button onClick={resetAccessibility} className="w-full flex items-center gap-2 text-xs font-primary text-gray-400 px-2 py-2 rounded-lg hover:bg-gray-50 transition-colors">
              <RotateCcw className="w-3.5 h-3.5" />
              Restaurar Padrão
            </button>
          </div>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-11 h-11 rounded-full bg-gray-700 hover:bg-gray-800 text-white shadow-lg flex items-center justify-center transition-all hover:scale-105"
        aria-label="Acessibilidade"
      >
        <Accessibility className="w-5 h-5" />
      </button>
    </div>
  );
}
